import React from 'react';
import { Col, Dropdown, DropdownButton, Row } from 'react-bootstrap';
import InputComponent from '../../../../components/Input';
import { CATEGORIES, vendorInputData } from '../../constants';
import styles from '../../../register/style.module.scss';

const FormInputs = ({ register, errors, selectedCategory, handleCategory }) => {
  return (
    <div>
      <Row className="mt-3">
        {vendorInputData.map((item) => (
          <>
            {item.type !== 'category' ? (
              <Col md={6} className="mb-3" key={item.name}>
                <InputComponent
                  title={item.title}
                  type={item.type}
                  name={item.name}
                  placeholder={item.placeholder}
                  {...register(item.name)}
                  error={errors[item.name]?.message}
                />
              </Col>
            ) : (
              <Col md={6} className="mb-3">
                <label className="text-muted my-2">{item.title}</label>
                <DropdownButton
                  id={styles.dropdown_basic_button}
                  variant="secondary"
                  title={selectedCategory ? selectedCategory.label : item.placeholder}
                >
                  {CATEGORIES.map((category, index) => (
                    <Dropdown.Item
                      key={index}
                      eventKey={category.value}
                      onClick={() => handleCategory(category)}
                    >
                      {category.label}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Col>
            )}
          </>
        ))}
      </Row>
    </div>
  );
};

export default FormInputs;
